import { type DetailSectionProps, DetailsBox } from '@/components/common/details/DetailsBox';
import { UserNameLink } from '@/components/common/UserNameLink';
import type { ApplicationVersionDetailedResponse } from '@/hooks/application_version';
import { dateTimeFormat } from '@/utility/date';

type Props = {
  applicationVersion: ApplicationVersionDetailedResponse;
};

export const ApplicationVersionDetails = ({ applicationVersion }: Props) => {
  const applicationVersionDetailsSections = [
    {
      items: {
        ID: {
          body: applicationVersion.id,
        },
        Version: { body: applicationVersion.version },
        'Core Version': { body: applicationVersion.coreVersion },
        'Created By': { body: <UserNameLink oid={applicationVersion.createdByOid} /> },
        Created: {
          body: new Date(applicationVersion.createdAt).toLocaleString(dateTimeFormat.local),
        },
      },
    },
  ] as DetailSectionProps[];

  return <DetailsBox sections={applicationVersionDetailsSections} title={'Application Version'} />;
};
